import { splitFollowups } from "./chatStream";

function TypingDots() {
  return (
    <span className="inline-flex gap-1">
      <span className="w-1.5 h-1.5 rounded-full bg-stone-400 animate-pulse"></span>
      <span className="w-1.5 h-1.5 rounded-full bg-stone-400 animate-pulse" style={{ animationDelay: "0.2s" }}></span>
      <span className="w-1.5 h-1.5 rounded-full bg-stone-400 animate-pulse" style={{ animationDelay: "0.4s" }}></span>
    </span>
  );
}

export default function MessageBubble({ msg, index, isLastAssistant, streaming, onFollowup }) {
  const { body, followups } = msg.role === "assistant"
    ? splitFollowups(msg.content)
    : { body: msg.content, followups: [] };
  const key = msg.id || `${msg.role}-${index}`;
  const showTyping = streaming && isLastAssistant && !body;

  return (
    <div key={key}>
      <div className={`flex ${msg.role === "user" ? "justify-end" : "justify-start"}`}>
        <div
          data-testid={`chat-msg-${msg.role}-${index}`}
          className={`max-w-[85%] rounded-2xl px-3.5 py-2.5 text-sm leading-relaxed whitespace-pre-wrap ${
            msg.role === "user"
              ? "bg-[color:var(--vv-onyx)] text-white rounded-br-md"
              : "bg-white border border-stone-200 text-stone-800 rounded-bl-md"
          }`}
        >
          {showTyping ? <TypingDots /> : body}
        </div>
      </div>
      {msg.role === "assistant" && !streaming && isLastAssistant && followups.length > 0 && (
        <div data-testid="chat-followups" className="mt-2 flex flex-wrap gap-2">
          {followups.map((q, k) => (
            <button
              key={`${key}-fu-${k}`}
              data-testid={`chat-followup-${k}`}
              onClick={() => onFollowup(q)}
              className="text-xs px-3 py-1.5 rounded-full bg-white border border-[color:var(--vv-gold)] text-[color:var(--vv-gold-deep)] hover:bg-[color:var(--vv-gold)] hover:text-[color:var(--vv-gold-deeper)] transition-colors"
            >
              {q}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
